import React from "react";
import { PageHero, Section } from "../components/PageShell";
import { ABOUT } from "../data/site";

const About = () => (
    <>
        <PageHero eyebrow={ABOUT.eyebrow} title={ABOUT.title} />

        <Section>
            <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-7 space-y-14">
                    {ABOUT.sections.map((s, i) => (
                        <div key={i} data-testid={`about-section-${i}`}>
                            <h2
                                className="font-display text-2xl lg:text-3xl font-bold tracking-tight mb-5"
                                style={{ color: "var(--ns-ink)" }}
                            >
                                {s.heading}
                            </h2>
                            <p
                                className="font-body text-[17px] leading-relaxed"
                                style={{ color: "var(--ns-body)" }}
                            >
                                {s.body}
                            </p>
                        </div>
                    ))}
                </div>
                <div className="lg:col-span-5">
                    <div className="sticky top-28">
                        <img
                            src={ABOUT.image}
                            alt="About Nador Sage International"
                            className="w-full aspect-[4/5] object-cover grayscale"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </Section>
    </>
);

export default About;
